/* eslint-disable max-len */
import 'react';

const ArrowLeftSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" {...props} >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(90.000000) translate(-12.000000, -12.000000) " fill="currentColor" fillRule="nonzero">
                <path d="M21.9514719,5.15147186 C22.420101,4.68284271 23.179899,4.68284271 23.6485281,5.15147186 C24.1171573,5.62010101 24.1171573,6.37989899 23.6485281,6.84852814 L12.8485281,17.6485281 C12.379899,18.1171573 11.620101,18.1171573 11.1514719,17.6485281 L0.351471863,6.84852814 C-0.117157288,6.37989899 -0.117157288,5.62010101 0.351471863,5.15147186 C0.820101013,4.68284271 1.57989899,4.68284271 2.04852814,5.15147186 L12,15.1029437 L21.9514719,5.15147186 Z" id="Rectangle-2" transform="translate(12.000000, 11.400000) scale(1, -1) translate(-12.000000, -11.400000) "></path>
            </g>
        </g>
    </svg>
);
export default ArrowLeftSvg;
